import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Tag.module.scss.js';

// Extend it with additional styles/texts
var Tag = function (_a) {
    var className = _a.className;
    return jsx("div", __assign({ className: clsx(styles.tag, className) }, { children: "Removed" }));
};

export { Tag };
